import React, { useState } from 'react';
import styled from './LoginPage.scss';
import { csrfToken } from 'src/utils/Utils';

const DeskHomePage = () => {
  const [deskSignIn, setDeskSignIn] = useState({ 'admin_user[email]': '', 'admin_user[password]': '' });

  const handleInputChange = ({ target }) => {
    const { name, value } = target;

    setDeskSignIn({ ...deskSignIn, [name]: value });
  };

  const { email, password } = deskSignIn;

  return (
    <div className={styled.form}>
      <form acceptCharset="UTF-8" className={styled.formElement} action="/desk/admin_users/sign_in" method='post'>
        <h2 className="text-center">Log in</h2>
        <input type="hidden" value={csrfToken()} name="authenticity_token" />
        <input type="hidden" name="utf8" value="✓" />
        <div className="form-group">
          <input
            type="text"
            autoFocus
            className="form-control"
            name="admin_user[email]"
            onChange={handleInputChange}
            placeholder="Username"
            required="required"
            value={email}
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            name="admin_user[password]"
            className="form-control"
            placeholder="Password"
            required="required"
            value={password}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <button type="submit" value="Log in" name="commit" data-disable-with="Log in" className="btn btn-primary btn-block">
            Log in
          </button>
        </div>
      </form>
    </div>
  );
};

export default DeskHomePage;
